import { useContext, useEffect, useMemo, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { IoMdArrowDropright } from "react-icons/io";
import { FaArrowRight } from "react-icons/fa";

import banner2 from "../assets/banner2.jpg";
import banner3 from "../assets/banner3.jpg";
import banner4 from "../assets/banner4.jpg";
import banner5 from "../assets/banner5.jpg";
import banner6 from "../assets/banner6.jpg";
import banner7 from "../assets/banner7.jpg";
import banner8 from "../assets/project1.jpeg";

import site from "../assets/site.jpg";

export const services = [
  {
    slug: "solar_power_solutions",
    title: "Solar Power Solutions",
    kicker: "Clean Energy for Everyone",
    desc:
      "Design, installation and maintenance of solar power systems for residential, commercial, industrial and agricultural use.",
    image: banner2,
  },
  {
    slug: "solar_water_pumping",
    title: "Solar Water Pumping Systems",
    kicker: "Sustainable Water Access",
    desc:
      "Efficient solar-powered water pumping solutions for agriculture, institutions and communities.",
    image: banner7,
  },
  {
    slug: "solar_heating_refrigeration",
    title: "Solar Water Heaters & Refrigeration",
    kicker: "Efficient Thermal Solutions",
    desc:
      "Solar water heating and refrigeration systems for hospitals, schools and residential buildings.",
    image: banner3,
  },
  {
    slug: "electrical_security_installations",
    title: "Electrical, CCTV & Fire Systems",
    kicker: "Power. Protection. Reliability.",
    desc:
      "Professional electrical installations, CCTV, security and fire systems for all sectors.",
    image: site,
  },
  {
    slug: "streetlights_wind_energy",
    title: "Solar Streetlights & Wind Energy",
    kicker: "Smart Infrastructure",
    desc:
      "Solar street lighting and wind energy system installations supported by experienced engineers.",
    image: banner6,
  },
  {
    slug: "maintenance_backup_services",
    title: "Maintenance & Backup Services",
    kicker: "Operational Continuity",
    desc:
      "Maintenance services for AC systems, generators, forklifts, PBX and technical infrastructure.",
    image: banner5,
  },
  {
    slug: "projects_track_record",
    title: "Projects & Track Record",
    kicker: "Proven Delivery",
    desc:
      "A strong track record delivering renewable energy and technical projects for institutions and individuals.",
    image: banner4,
  },
  {
    slug: "drilling",
    title: "Borehole drilling and geophysical survey",
    kicker: "Modern tools & technology",
    desc:
      "Professional borehole drilling and geophysical surveys to locate water, ensure quality, and optimize extraction.",
    image: banner8,
  },
];

export default function ServicesBanner1() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  const isHome = !appContext.navItem || appContext.navItem === "home";

  const servicesToRender = useMemo(
    () => (isHome ? services.slice(0, 4) : services),
    [isHome]
  );

  function openService(service) {
    appContext.navTo({
      item: "services",
      subItem: service.slug,
    });
  }

  if (!ready)
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );

  return (
    <section className="MainBodySection py-5 fr-services-wrap">
      <div className="container">
        {/* Header */}
        <div className="row justify-content-center mb-5">
          <div className="col-lg-8 text-center">
            <p className="fr-kicker-dark mb-2 fw-bold">
              OUR SERVICES
            </p>
            <h2 className="fw-bold text-secondary mb-3">
              Renewable & Technical Solutions
            </h2>
            <p className="text-muted mb-0">
              Practical, affordable and scalable energy solutions designed for
              Tanzania and beyond.
            </p>
          </div>
        </div>

        {/* Services Grid */}
        <div className="row g-4">
          {servicesToRender.map((service) => (
            <div key={service.slug} className="col-md-6 col-lg-3">
              <article className="fr-service-card h-100 d-flex flex-column align-items-center justify-content-between">
                {/* Image */}
                <div
                  className="fr-service-card-media overflow-hidden rounded"
                  onClick={() => openService(service)}
                  aria-label={`Open ${service.title}`}
                  style={{ width: "100%", height: "210px" }}
                >
                  <img
                    src={service.image}
                    alt={service.title}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "block",
                    }}
                  />
                </div>

                {/* Content */}
                <div className="fr-service-card-body text-center">
                  <span className="fr-service-kicker">
                    {service.kicker}
                  </span>
                  <h6 className="fw-bold text-secondary mt-2 mb-2">
                    {service.title}
                  </h6>
                  <p className="small text-muted mb-3">
                    {service.desc}
                  </p>

                  <button
                    className="btn btn-secondary btn-rounded py-2 px-3 btn-sm d-inline-flex align-items-center gap-2"
                    onClick={() => openService(service)}
                  >
                    <FaArrowRight size={14} />
                  </button>
                </div>
              </article>
            </div>
          ))}
        </div>

        {/* CTA */}
        {isHome && (
          <div className="text-center mt-5">
            <button
              className="btn btn-secondary px-4 py-2 d-inline-flex align-items-center gap-2"
              onClick={() => appContext.navTo({ item: "services" })}
            >
              View All Services <IoMdArrowDropright size={22} />
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
